import type { EvaluationRun } from '../../services/evaluationRun.interface.js';

export interface EvaluationRunGroup {
  key: string;
  name: string;
  latest: EvaluationRun;
  runs: EvaluationRun[];
}

export interface LoadedRunWindow {
  oldest: string;
  newest: string;
}

export function getLoadedRunWindow(
  runs: EvaluationRun[],
): LoadedRunWindow | undefined {
  const first = runs[0];
  if (!first) return undefined;
  let oldest = first.systemProperties.createdDate;
  let newest = oldest;
  for (const run of runs) {
    const date = run.systemProperties.createdDate;
    if (Date.parse(date) < Date.parse(oldest)) oldest = date;
    if (Date.parse(date) > Date.parse(newest)) newest = date;
  }
  return { oldest, newest };
}

export function groupEvaluationRuns(
  runs: EvaluationRun[],
): EvaluationRunGroup[] {
  const unique = new Map<string, EvaluationRun>();
  for (const run of runs) {
    const key = JSON.stringify([run.workspaceName, run.id]);
    if (!unique.has(key)) unique.set(key, run);
  }
  const ordered = [...unique.values()].sort(
    (a, b) =>
      Date.parse(b.systemProperties.createdDate) -
        Date.parse(a.systemProperties.createdDate) || a.id.localeCompare(b.id),
  );
  const groups = new Map<string, EvaluationRunGroup>();
  for (const run of ordered) {
    const name = run.displayName?.trim() ? run.displayName : null;
    const key = JSON.stringify([
      run.workspaceName,
      name === null ? 'run' : 'name',
      name ?? run.id,
    ]);
    const group = groups.get(key);
    if (group) group.runs.push(run);
    else
      groups.set(key, {
        key,
        name: name ?? run.id,
        latest: run,
        runs: [run],
      });
  }
  return [...groups.values()];
}
